export class SupervivenciaResponse {
    certificados:Supervivencia[];
    participantes:any;
    
}

export class Supervivencia{
    numeroControl:string = '';
    fechaIngreso:string = '';
    encargado:string = '';
    fechaVencimiento:string = '';
    observacion:string = '';
    tipoCapacidad:string = '';
    
    
}